// In-memory dashboard card snapshots (survive personal hub section switches).

const store = new Map();
const MAX_ENTRIES = 48;

/** @param {string} viewerKey @param {number|string} handleId @param {string} cardId */
export function dashboardCardCacheKey(viewerKey, handleId, cardId) {
  return `dashboard:${cardId}:${viewerKey}:h:${handleId}`;
}

/** @param {string} key */
export function getDashboardCardBoot(key) {
  return store.get(key) ?? null;
}

/** @param {string} key @param {object} payload */
export function setDashboardCardCache(key, payload) {
  if (!key) return;
  store.set(key, { ...payload, at: Date.now() });

  if (store.size > MAX_ENTRIES) {
    let oldestKey = null;
    let oldestAt = Infinity;
    for (const [k, v] of store.entries()) {
      if (v.at < oldestAt) {
        oldestAt = v.at;
        oldestKey = k;
      }
    }
    if (oldestKey) store.delete(oldestKey);
  }
}

/** @param {string} [key] */
export function clearDashboardCardCache(key) {
  if (key) store.delete(key);
  else store.clear();
}
